import { XMLBuilder } from "fast-xml-parser";
import { type FetchElement } from "./model.js";
import { validateRoot } from "./validation.js";

function toObject(node: FetchElement): Record<string, unknown> {
  const out: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(node.attributes)) {
    out[`@_${key}`] = typeof value === "boolean" ? String(value) : value;
  }

  if (node.text !== undefined) {
    out["#text"] = node.text;
  }

  for (const child of node.children) {
    const childObject = toObject(child);
    const existing = out[child.name];
    if (existing === undefined) {
      out[child.name] = [childObject];
    } else {
      (existing as Array<Record<string, unknown>>).push(childObject);
    }
  }

  return out;
}

export function toFetchXml(node: FetchElement): string {
  validateRoot(node);
  const builder = new XMLBuilder({
    ignoreAttributes: false,
    attributeNamePrefix: "@_",
    textNodeName: "#text",
    format: true,
    suppressEmptyNode: true,
    suppressBooleanAttributes: false,
  });

  return builder.build({ [node.name]: toObject(node) });
}
